import { PrimeVueLocaleOptions } from 'primevue/config';
import { i18n } from '../../vue';
import { de } from './de';
import { en } from './en';

export function getLocale(): PrimeVueLocaleOptions {
  switch (i18n.global.locale) {
    case 'de':
      return de;
    case 'en':
      return en;
    default:
      return de;
  }
}
